<template>
    <Heading>{{ $t("Change password") }}</Heading>

    <div v-if="state.currentPhase === 'request'">
        <p>
            {{ $t("Click on the button below to request a change password link.") }}
            {{
                $t("You will receive in a few minutes a link in your email inbox with the instructions to change your account password.")
            }}
        </p>

        <Button ref="requestChangeLinkButton" @click="sendEmail" class="mt-5">
            {{ $t("Request change password link") }}
        </Button>
    </div>
    <div v-else-if="state.currentPhase === 'form'">
        <p class="mb-5">
            {{ $t("Fill this form to change your password. You have received your secret code in your email inbox.") }}
        </p>
        <form @submit.prevent="submit" class="sm:w-1/2">
            <FormInput v-model="form.old_password" :error="form.errors.old_password" :label="$t('Current password')"
                       type="password" name="old_password" icon="fa-solid fa-key" class="mb-6"/>
            <FormInput v-model="form.password" :error="form.errors.password" :label="$t('Password')" name="password"
                       type="password" icon="fa-solid fa-key" class="mb-6"/>
            <FormInput v-model="form.password_confirmation" :error="form.errors.password_confirmation"
                       :label="$t('Confirm password')" name="password_confirmation" icon="fa-solid fa-key"
                       type="password" class="mb-6"/>
            <FormInput v-model="form.secret_code" :error="form.errors.secret_code" :label="$t('Secret code')"
                       name="secret_code" icon="fa-solid fa-key" class="mb-6"/>
            <Button ref="changePasswordButton" :disabled="form.processing">{{ $t("Change password") }}</Button>
        </form>
    </div>

</template>

<script setup>
import Heading from "@/Shared/Heading";
import FormInput from "@/Shared/FormInput";
import Button from "@/Shared/Button";
import {useForm} from "@inertiajs/inertia-vue3";
import {reactive, ref} from "vue";
import axios from "axios";

const props = defineProps({
    phase: {
        type: String,
        default: 'request'
    },
    code: {
        type: String,
        default: null
    }
})

const form = useForm({
    old_password: null,
    password: null,
    password_confirmation: null,
    secret_code: props.code
})

const state = reactive({
    currentPhase: props.phase
})

const requestChangeLinkButton = ref(null);
const changePasswordButton = ref(null);

function sendEmail() {
    requestChangeLinkButton.value.toggleLoading();
    axios.post(route('user.change_password.request_code'))
        .then(() => {
            state.currentPhase = 'form'
            requestChangeLinkButton.value.toggleLoading();
        })
}

function submit() {
    changePasswordButton.value.toggleLoading();
    form.post(route('user.change_password'), {
        preserveScroll: true,
        onError: () => changePasswordButton.value.toggleLoading()
    })
}
</script>
